import React, { useState, useEffect } from "react"
import { Container, Grid } from "@material-ui/core"
import { ButtonHLPure, GridPure, HeaderHLPure, ModalUtil } from "../../pures"
import downloadIcon from '../../../assets/logos/downloadIcon.png'
import { ExternalDropZone, Upload } from "@progress/kendo-react-upload"
import { OfferService, PublicityService, BranchOfficeService } from '../../../services'
import Papa from 'papaparse'
import { useHistory } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import "./upload-multiple.css"

const UploadMultipleView = (props) => {
  const {
    optionSelected,
    transl,
    uploadRef,
    onStatusChange
  } = props

  const apiUrl = process.env.REACT_APP_ETICKET_API
  const offerService = new OfferService(apiUrl)
  const publicityService = new PublicityService(apiUrl)
  const branchOfficeService = new BranchOfficeService(apiUrl)
  const modalUtil = new ModalUtil()
  const token = JSON.parse(localStorage.getItem('token')).accessToken
  const history = useHistory()
  const { t } = useTranslation()

  const [data, setData] = useState([])
  const [file, setFile] = useState(false)
  const [arrayOfKeys, setArrayOfKeys] = useState([])

  const itemChange = (event) => {
    const inEditID = event.dataItem.id;
    const field = event.field || "";
    const newData = data?.map((item) =>
      item.id === inEditID
        ? {
          ...item,
          [field]: event.value,
        }
        : item
    );
    setData(newData);
  };

  const handleImageUpload = (file) => {
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const base64String = e.target.result.split(',')[1];
        let csvText = base64ToUtf8(base64String);
        csvText = Papa.parse(csvText, { header: true, skipEmptyLines: true })

        csvText = csvText.data.map((item, key) => {
          return { id: key + 1, ...item }
        })

        setData(csvText)
        setFile(true)
      };

      reader.readAsDataURL(file);
    } else {
      setFile(false)
      setData([])
    }
  }

  const base64ToUtf8 = (base64) => {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder('utf-8').decode(bytes);
  };

  const sendData = async () => {
    modalUtil.showModal('loading', t('modal.pure.loading.message'), t('modal.pure.loading.title'))

    try {
      // Copy the data
      let auxData = JSON.parse(JSON.stringify(data))

      let hashTableFunctions = {
        '/offers-csv': {
          execute: offerService.massiveOffer.bind(offerService),
          modal: () => { modalUtil.showModal('success', transl('success.offer'), t('modal.pure.title.success'), () => history.push('/offers')) }
        },
        '/publicities-csv': {
          execute: publicityService.massivePublicities.bind(publicityService),
          modal: () => { modalUtil.showModal('success', transl('success.publicity'), t('modal.pure.title.success'), () => history.push('/publicity')) }
        },
        '/branch-office-csv': {
          execute: branchOfficeService.massiveBranchOffices.bind(branchOfficeService),
          modal: () => { modalUtil.showModal('success', transl('success.branchOffice'), t('modal.pure.title.success'), () => history.push('/branch-offices-administration')) }
        }
      }

      let optionMassiveSelected

      if (optionSelected.endpoint) {
        optionMassiveSelected = hashTableFunctions[optionSelected.endpoint]
      }

      const newMassiveData = await optionMassiveSelected.execute(auxData, token)
      if (newMassiveData && newMassiveData.data && Number(newMassiveData.statusCode) === 200) {
        optionMassiveSelected.modal()
      } else {
        modalUtil.showModal('error', t('modal.pure.messsage.error'), t('modal.pure.title.error'))
      }
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', t('modal.pure.messsage.error'), t('modal.pure.title.error'))
    }
  }

  useEffect(() => {
    if (file) {
      let keys = Object.keys(data[0])
      keys = keys.filter((value) => value !== 'id')

      let keyArray = keys.map((key) => {
        return (
          {
            field: key,
            title: key, //'Nombre'
            width: 150,
            editable: true
          }
        )
      })

      setArrayOfKeys(keyArray)
    }
  }, [file])

  const handleBack = () => history.goBack()

  return (
    <Container className="view-container uploadMultipleView">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderHLPure title={optionSelected?.header} />
        </Grid>
        <Grid item xs={12}>
          <Container maxWidth="md" disableGutters>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <h5 style={{ fontSize: '18px', margin: 0 }}>{transl('titleLeft') + optionSelected?.titleLeftComplement}</h5>
                <ol style={{ paddingLeft: '15px' }}>
                  <li>{transl('step1')}</li>
                  <li>{transl('step2')}</li>
                  <li>{transl('step3')}</li>
                </ol>
                <div className='button-container'>
                  <a download style={{ textDecoration: 'none' }} className="buttonHLPure buttonHLPure-secondary outlined space-button button-downloads" href={optionSelected?.fileDownload}>
                    <img src={downloadIcon} width="25" style={{ paddingRight: '5px' }}></img>
                    {transl('downloadButton')}
                  </a>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <ExternalDropZone uploadRef={uploadRef} style={{ border: '3px dashed rgb(0 0 0 / 20%)', backgroundColor: '#00000000', color: 'rgb(0 0 0 / 40%)', fontWeight: '600', fontFamily: '"Quicksand"' }} customHint={transl('customHint')} />
                <Upload
                  onStatusChange={onStatusChange}
                  ref={uploadRef}
                  batch={false}
                  multiple={false}
                  defaultFiles={[]}
                  withCredentials={false}
                  autoUpload={false}
                  showActionButtons={false}
                  accept=".csv"
                  localization={{
                    dropFilesHere: transl('customHint')
                  }}
                  onAdd={(ev) => {
                    if (ev.target.files[0]) {
                      const file = ev.target.files[0].getRawFile()
                      handleImageUpload(file)
                    }
                  }}
                  onRemove={() => {
                    handleImageUpload(null)
                  }}
                />
              </Grid>
              {
                data.length > 0 &&
                <Grid item xs={12}>
                  <GridPure
                    style={{ overflow: 'hidden' }}
                    dataGrid={data?.map((item) => ({
                      ...item,
                      inEdit: true,
                    }))}
                    skip={0}
                    take={5}
                    rowsItems={arrayOfKeys}
                    // onRowClick={rowClick}
                    editField="inEdit"
                    onItemChange={itemChange}
                  >
                  </GridPure>
                </Grid>
              }
              <Grid item xs={12} className="button-actions">
                <ButtonHLPure
                  colorScheme="error" outlined
                  nameBtn={transl("button.goBack")}
                  onClick={handleBack}
                />
                <ButtonHLPure
                  colorScheme="primary" outlined
                  nameBtn={t("button.save")}
                  onClick={sendData}
                />
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container >
  );
}

export { UploadMultipleView as default };